//// Application Modules
import { configureStore, combineReducers } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'

//// Application Slices
import settingReducer from './reducers/settingSlice'
import cacheReducer from './reducers/cacheSlice'
import authorizationReducer from './reducers/authorizationSlice'
import accountReducer from './reducers/accountSlice'
import formReducer from './reducers/formSlice'

// Combine Redux Reducers
const rootReducer = combineReducers({
    settings: settingReducer,
    cache: cacheReducer,
    authorizations: authorizationReducer,
    account: accountReducer,
    forms: formReducer,
})

// Persist Redux Reducers
const persistedReducer = persistReducer(
    {
        key: 'root',
        storage,
    },
    rootReducer
)

// Configure Redux Store
export const store = configureStore({
    reducer: persistedReducer,
})

// Persist Redux Store
export const persistor = persistStore(store)
